import React, {useRef, useState, useEffect} from 'react'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useContentAsset from '../../../hooks/use-content-asset'
import {useGlobaleContext} from '../../../contexts/globale'

const ASSET_ID = 'cart-endorsement-callout'

const CartEndorsementCallout = () => {
    const cartStyles = useMultiStyleConfig('CartStyles')
    const {data: contentAsset} = useContentAsset(ASSET_ID)
    const {globaleCountry} = useGlobaleContext()
    const containerRef = useRef(null)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (!contentAsset?.contentAssetHTML || !containerRef.current) return

        const root = containerRef.current.querySelector('[data-enable-for-globale]')
        const enableForGlobale = root?.getAttribute('data-enable-for-globale') === 'true'
        const isGlobaleUser = globaleCountry && globaleCountry !== 'US'

        if (isGlobaleUser && !enableForGlobale) {
            setVisible(false)
        } else {
            setVisible(true)
        }
    }, [contentAsset, globaleCountry])

    if (!contentAsset?.contentAssetHTML) return null

    return (
        <Box
            ref={containerRef}
            className="cart-endorsement-callout-wrapper"
            display={visible ? 'block' : 'none'}
            {...cartStyles.cartEndorsementCallout}
            dangerouslySetInnerHTML={{__html: contentAsset.contentAssetHTML}}
        />
    )
}

export default CartEndorsementCallout
